import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/VipGameCommissionAction";

export const VipGameCommissionEffDialog = ({
  setQueryParams,
  queryParams,
  setSwalProps,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const startOfYesterday = new Date(new Date().setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(new Date().setHours(23, 59, 59, 999));
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const vipGameCommissionState = useSelector(
    ({ vipGameCommission }) => vipGameCommission,
    shallowEqual
  );

  const handleClose = () => setQueryParams(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {};

  useEffect(() => {
    if (queryParams) {
      setFromDate(queryParams.fromdate);
      setToDate(queryParams.todate);
      dispatch(actions.fetchVipGameCommissionEffList(queryParams)).then(
        (resp) => {
          resp = resp.data;

          if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        }
      );
    }
  }, [queryParams]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        show={!!queryParams}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "vipGameCommissionEff",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="d-flex gap-2 align-items-center flex-wrap">
            <div className="border rounded">
              <DateRangeComp
                initialRange={[
                  { startDate: fromDate, endDate: toDate, key: "selection" },
                ]}
                onDateChange={handleDateChange}
              />
            </div>
            <select
              className="dropdown respond-Select"
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
            >
              {vipGameCommissionState.vipGameCommissionUi?.levelLists?.map(
                (value, index) => (
                  <option key={index} value={value.code}>
                    {value.description}
                  </option>
                )
              )}
            </select>
            <div className="d-flex flex-fill justify-content-end">
              <button className="btn btn-primary" onClick={handleSearchClick}>
                {intl.formatMessage({ id: "search" })}
              </button>
            </div>
          </div> */}
          {vipGameCommissionState.vipGameCommissionEffList && (
            <div
              className={`rounded w-100`}
              style={{
                border: "1px solid grey",
                padding: "2px",
                margin: "10px 0 ",
                overflow: "auto",
              }}
            >
              <table
                className="text-start table-report"
                style={{
                  width: "100%",
                  minWidth: "800px",
                }}
              >
                <tbody>
                  <tr>
                    <td className="col-3 ps-2 td-line">
                      {intl.formatMessage({ id: "gameBet" }) +
                        " : " +
                        vipGameCommissionState.vipGameCommissionEffList
                          ?.totalgamebet}
                    </td>
                    <td className="col-3 ps-2 td-line">
                      {intl.formatMessage({ id: "gameWin" }) +
                        " : " +
                        vipGameCommissionState.vipGameCommissionEffList
                          ?.totalgamewin}
                    </td>
                    <td className="col-3 ps-2 td-line">
                      {intl.formatMessage({ id: "promoClaimed" }) +
                        " : " +
                        vipGameCommissionState.vipGameCommissionEffList
                          ?.totalpromoclaimed}
                    </td>
                    <td className="col-3 ps-2 td-line">
                      {intl.formatMessage({ id: "winLose" }) +
                        " : " +
                        vipGameCommissionState.vipGameCommissionEffList
                          ?.totalactamount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <div
            className="member-div d-flex"
            style={{
              margin: "10px auto",
            }}
          >
            <div className="member-container">
              <div className="table-responsive">
                <table className="member-table">
                  <thead className="member-header1">
                    <tr className="member-row1">
                      <th className="member-cell hide-on-mobile">
                        {intl.formatMessage({ id: "no" })}
                      </th>
                      <th className="member-cell text-start text-nowrap">
                        {intl.formatMessage({ id: "username" })}
                      </th>
                      <th className="member-cell text-end text-nowrap">
                        {intl.formatMessage({ id: "gameBet" })}
                      </th>
                      <th className="member-cell text-end text-nowrap">
                        {intl.formatMessage({ id: "gameWin" })}
                      </th>
                      <th className="member-cell text-end text-nowrap">
                        {intl.formatMessage({ id: "promoClaimed" })}
                      </th>
                      <th className="member-cell text-end text-nowrap">
                        {intl.formatMessage({ id: "winLose" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="member-body">
                    {vipGameCommissionState.vipGameCommissionEffList
                      ?.memberVipCommEffLists.length > 0 ? (
                      vipGameCommissionState.vipGameCommissionEffList?.memberVipCommEffLists.map(
                        (report, index) => (
                          <tr key={index} className="member-row1">
                            <td className="member-cell hide-on-mobile">
                              {index + 1}
                            </td>
                            <td className="member-cell text-start">
                              {report.username}
                            </td>
                            <td className="member-cell text-end">
                              {report.gamebet}
                            </td>
                            <td className="member-cell text-end">
                              {report.gamewin}
                            </td>
                            <td className="member-cell text-end">
                              {report.promoclaimed}
                            </td>
                            <td className="member-cell text-end">
                              {report.actamount}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="6">
                          <div className="no-record-wrapper oRecordDiv">
                            <i className="bi bi-search fs-1 mb-3" />
                            <div className="text-font2">
                              {intl.formatMessage({ id: "noRecordFound" })}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
